import React, { useContext } from "react";
import PropTypes from "prop-types";

import { InvoiceTemplateContext } from "../InvoiceTemplateContext";
import SelectableElement from "./SelectableElement";
import SelectableSection from "./SelectableSection";
import ValuePlaceholder from "./ValuePlaceholder";

const InvoiceSectionViewer = ({ invoiceData }) => {
  const { logo, invoiceSection, bilingualEnabled } = invoiceData;
  const { state } = useContext(InvoiceTemplateContext);

  const {
    fields,
    headingStyle,
    logoWidth,
    headingFieldWidth,
    dateTime,
    serialNo,
    no,
  } = invoiceSection;

  const dateTimeVI = dateTime.label.vi.split(" ");
  const dateTimeEN = dateTime.label.en.split(" ");
  let name = "";
  const dateTimeSection = dateTimeVI.map((item, index) => {
    if (index === 0) {
      name = "day";
    }
    if (index === 1) {
      name = "month";
    }
    if (index === 2) {
      name = "year";
    }
    return {
      name,
      vi: { label: item, style: dateTime.labelStyle.vi },
      en: { label: dateTimeEN[index], style: dateTime.labelStyle.en },
    };
  });

  return (
    <SelectableSection
      section="invoiceSection"
      isSelectable={invoiceSection.isSelectable}
    >
      <table width="100%">
        <tbody>
          <tr>
            <td style={{ width: logoWidth }}>
              {logo.enabled && (
                <div className="logo-container">
                  <img
                    src={invoiceData.logo.url}
                    style={invoiceData.logo.style}
                  />
                </div>
              )}
            </td>
            <td style={{ ...headingStyle, width: headingFieldWidth }}>
              {fields
                .filter(field => field.visible)
                .filter(field => {
                  if (state.invoiceForm === "Conversion") {
                    return true;
                  }

                  if (state.invoiceForm === "Electronic") {
                    return field.visibleOnInvoiceForm !== "Conversion";
                  }
                })
                .map((field, index) => (
                  <div key={index}>
                    <SelectableElement
                      as="div"
                      style={field.labelStyle.vi}
                      id={`invoiceSection.fields[${index}].label.vi`}
                      stylePath={`invoiceSection.fields[${index}].labelStyle.vi`}
                    >
                      {field.label.vi}
                    </SelectableElement>

                    {bilingualEnabled && field.label.en && (
                      <SelectableElement
                        as="div"
                        style={field.labelStyle.en}
                        id={`invoiceSection.fields[${index}].label.en`}
                        stylePath={`invoiceSection.fields[${index}].labelStyle.en`}
                      >
                        &nbsp;{field.label.en}
                      </SelectableElement>
                    )}
                  </div>
                ))}

              {dateTimeSection &&
                dateTimeSection.map((field, index) => (
                  <span key={index} style={{marginRight: "10px"}}>
                    <SelectableElement
                      as="span"
                      style={field.vi.style}
                      id={`invoiceSection.dateTime.label.vi`}
                      stylePath={`invoiceSection.dateTime.labelStyle.vi`}
                    >
                      {field.vi.label}
                    </SelectableElement>

                    {bilingualEnabled && (
                      <SelectableElement
                        as="span"
                        style={field.en.style}
                        id={`invoiceSection.dateTime.label.en`}
                        stylePath={`invoiceSection.dateTime.labelStyle.en`}
                      >
                        &nbsp;{field.en.label}
                      </SelectableElement>
                    )}
                    <ValuePlaceholder placeholderKey={field.name}>
                      {" "}
                    </ValuePlaceholder>
                  </span>
                ))}
            </td>
            <td style={{ width: "30%" }}>
              <div>
                <SelectableElement
                  as="span"
                  style={serialNo.labelStyle.vi}
                  id={`invoiceSection.serialNo.label.vi`}
                  stylePath={`invoiceSection.serialNo.labelStyle.vi`}
                >
                  {serialNo.label.vi}
                </SelectableElement>
                {bilingualEnabled && (
                  <SelectableElement
                    as="span"
                    style={serialNo.labelStyle.en}
                    id={`invoiceSection.serialNo.label.en`}
                    stylePath={`invoiceSection.serialNo.labelStyle.en`}
                  >
                    &nbsp;{serialNo.label.en}
                  </SelectableElement>
                )}
                <SelectableElement
                  as="span"
                  style={serialNo.delimiterStyle}
                  id={`invoiceSection.serialNo.delimiter`}
                  stylePath={`invoiceSection.serialNo.delimiterStyle`}
                >
                  {serialNo.delimiter}&nbsp;
                </SelectableElement>
                <SelectableElement
                  as="span"
                  style={serialNo.valueStyle}
                  id={`invoiceSection.serialNo.value`}
                  stylePath={`invoiceSection.serialNo.valueStyle`}
                >
                  <ValuePlaceholder placeholderKey={serialNo.name}>
                    {serialNo.type}
                    {serialNo.prefix}
                    {serialNo.value}
                  </ValuePlaceholder>
                </SelectableElement>
              </div>

              <div>
                <SelectableElement
                  as="span"
                  style={no.labelStyle.vi}
                  id={`invoiceSection.no.label.vi`}
                  stylePath={`invoiceSection.no.labelStyle.vi`}
                >
                  {no.label.vi}
                </SelectableElement>
                {bilingualEnabled && (
                  <SelectableElement
                    as="span"
                    style={no.labelStyle.en}
                    id={`invoiceSection.no.label.en`}
                    stylePath={`invoiceSection.no.labelStyle.en`}
                  >
                    {" "}
                    {no.label.en}
                  </SelectableElement>
                )}
                <SelectableElement
                  as="span"
                  style={no.delimiterStyle}
                  id={`invoiceSection.no.delimiter`}
                  stylePath={`invoiceSection.no.delimiterStyle`}
                >
                  {no.delimiter}{" "}
                </SelectableElement>
                <SelectableElement
                  as="span"
                  style={no.valueStyle}
                  id={`invoiceSection.no.value`}
                  stylePath={`invoiceSection.no.valueStyle`}
                >
                  <ValuePlaceholder placeholderKey={no.name}>
                    {no.value}{" "}
                  </ValuePlaceholder>
                </SelectableElement>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </SelectableSection>
  );
};

InvoiceSectionViewer.propTypes = {
  invoiceData: PropTypes.object,
};

export default InvoiceSectionViewer;
